import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_ALL_POST_ROLES = gql`
  query Get($type: String!) {
    getAllPostRoles(search: $type) {
      roles
    }
  }
`;

const getAllPostRoles = async (type) => {
  try {
    const result = await client
      .query({
        query: GET_ALL_POST_ROLES,
        variables: { type },
        errorPolicy: 'all',
        fetchResults: true,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getAllPostRoles: postsByTypeData },
    } = result;

    if (postsByTypeData) {
      return postsByTypeData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getAllPostRoles = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getAllPostRoles Error: ${error}`);
    return null;
  }
};

export default getAllPostRoles;
